import React from "react";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import Breadcrump from "../../components/Breadcrump";
import { Col, Row } from "react-bootstrap";

function DashboardLayout() {
  return (
    <>
      <Breadcrump title="My Account" />

      <div className="custom-profile-wrapper py-5">
        <div className="container">
          <Row className="gx-lg-3 gx-2">
            <Col lg={3} className="mb-4 mb-lg-0">
              <Sidebar />
            </Col>

            <Col lg={9}>
              <Outlet />
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}

export default DashboardLayout;
